<template>
    <TransactionalScreen @setLanguage="setLanguage" :title="$t('login.Lost password')" hideLogo clickableLogo @clickOnLogo="$router.push({ name: 'login' })">
        <FormRoot @submit="askPassword" @keyup="form.keyUp()" class="form">

            <!-- Email -->
            <Field
                    :form.sync="form"
                    type="text"
                    name="email"
                    :placeholder="$t('login.Your e-mail')"
                    :hint="$t('login.Your e-mail')"
                    @input="form.errors.clear()"
                    focus
            />
            <!-- / Email -->

            <template v-if="form.success">
                <Alert v-if="form.success.success" color="success" icon="check">{{ form.success.message }}</Alert>
                <Alert v-else color="warning" icon="exclamation-circle">{{ form.success.message }}</Alert>
            </template>

            <!-- Submit -->
            <div class="text-center">
                <Button type="submit" color="primary" large class="mt-4" :disabled="!form.submittable || loading">{{ $t('login.Reset password') }}</Button>
            </div>
            <!-- / Submit -->

            <div class="mt-4"><router-link :to="{ name: 'login' }" class="text-muted"><Icon icon="angle-left"/> {{ $t('login.Back') }}</router-link></div>

        </FormRoot>
    </TransactionalScreen>
</template>

<script>
    import { TransactionalScreen, Form, FormRoot, Field, Button, Alert } from '@tech_hexeko/design-system'
    import {store} from "../../index";

    export default {
        props: {
            reset_password_url: String
        },
        data () {
            return {
                form: new Form({
                    email: null
                }),
                loading: false
            }
        },
        methods: {
            askPassword() {
                this.loading = true
                this.form.submit(() => {
                    return this.$api.authenticate.forgotPassword({
                        email: this.form.email,
                        store_id: this.$store.getters['auth/getConfig'].store_id
                    })
                }).finally(() => {
                    this.loading = false
                });
            },
            setLanguage(lang) {
                store.dispatch('lang/setLanguage', lang)
            }
        },
        components: {
            Field,
            FormRoot,
            Button,
            Alert,
            TransactionalScreen
        }
    }
</script>
